import React from "react";

const SellYourKicks = () => (
  <div className="text-center p-8 bg-white rounded-3xl shadow-xl max-w-2xl mx-auto mt-8">
    <h1 className="text-4xl sm:text-5xl font-extrabold text-center text-gray-900 mb-4 leading-tight">
      Sell Your Shoes
    </h1>
    <p className="text-lg text-gray-700 mb-6">
      We buy new and gently used shoes in good condition. If you have sneakers
      you'd like to sell, fill out the form below with details about your shoes
      (brand/model, size, condition, and your asking price). Our team will
      review your submission and reply promptly!
    </p>
    <form
      className="space-y-4 max-w-sm mx-auto"
      onSubmit={async (e) => {
        e.preventDefault();
        const name = e.target[0].value;
        const email = e.target[1].value;
        const description = e.target[2].value;

        const res = await fetch("/.netlify/functions/contact-form", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            name,
            email,
            subject: "Sell Your Shoes Inquiry",
            message: `Sell Your Shoes Inquiry:\n${description}`,
          }),
        });
        const data = await res.json();
        if (data.success) {
          alert("Your submission was sent! We'll reply promptly.");
          e.target.reset();
        } else {
          alert("Failed to send your submission.");
        }
      }}
    >
      <input
        type="text"
        placeholder="Your Name"
        className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-500"
        required
      />
      <input
        type="email"
        placeholder="Your Email"
        className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-500"
        required
      />
      <textarea
        placeholder="Describe your shoes (brand/model, size, condition, asking price)"
        rows="5"
        className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-500"
        required
      />
      <button
        type="submit"
        className="w-full py-3 bg-indigo-600 text-white rounded-xl font-bold text-lg mt-2"
      >
        Submit
      </button>
    </form>
  </div>
);

export default SellYourKicks;
